import { createContext } from "react";

export const HomeContext = createContext({
    dataContext: { 
        clients: [],
        videos: [],
        loaded: false
    },
    setDataContext: undefined,
});